import { render, staticRenderFns } from "./LocalValidateTokenGoogle.vue?vue&type=template&id=ff34b6f0&lang=pug"
import script from "./LocalValidateTokenGoogle.vue?vue&type=script&lang=js"
export * from "./LocalValidateTokenGoogle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports